export default "__VITE_ASSET__0d0646eb__"